export const truncateFilename = (filename, maxLength = 32) => {
    if (!filename || filename.length <= maxLength)
        return filename;
    const lastDot = filename.lastIndexOf('.');
    if (lastDot <= 0)
        return `${filename.slice(0, maxLength - 1)}…`;
    const ext = filename.slice(lastDot);
    const name = filename.slice(0, lastDot);
    const available = maxLength - ext.length - 1;
    if (available <= 0)
        return `${filename.slice(0, maxLength - 1)}…`;
    return `${name.slice(0, available)}…${ext}`;
};
